import {ENDPOINT_COMMUNITY} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const search = (token, strSearch) => {
  return fetch(`${ENDPOINT_COMMUNITY}search?${strSearch}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  search,
};
